import axios from 'axios'
import config from '../config.json'
import auth from './authService'
import logger from './logService'

let isRefreshCalled = false

axios.defaults.baseURL = config.apiUrl
// axios.defaults.headers.common['Authorization'] = config.jwtPrefix + AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
//     'Content-Type': 'multipart/form-data',

// Add a request interceptor
axios.interceptors.request.use(
  async request => {
    if (!auth.getCurrentUser()) localStorage.removeItem(config.tokenKey)

    const token = localStorage.getItem(config.tokenKey) || sessionStorage.getItem(config.tokenKey) || sessionStorage.getItem('visitorToken') || localStorage.getItem('tokenKey')
    const userId = localStorage.getItem('user_id')
    if (token) {
      request.headers['Authorization'] = config.jwtPrefix + token
    }
    if (userId) {
      request.headers['User-Id'] = userId
    }

    let originalRequest = request
    const path_is_not_login =
      window.location.pathname !== '/' &&
      window.location.pathname !== '/about' &&
      window.location.pathname !== '/otpverify'
    const tokenIsExpired = auth.IsTokenAboutToExpired()

    if (tokenIsExpired && path_is_not_login && !isRefreshCalled) {
      try {
        isRefreshCalled = true
        const newCompanyToken = await auth.renewToken(token)
        localStorage.setItem('token', newCompanyToken)

        const authToken = localStorage.getItem('auth_token')
        if (authToken) {
          const newAuthToken = await auth.renewToken(authToken)
          localStorage.setItem('auth_token', newAuthToken)
        }

        originalRequest.headers['Authorization'] = config.jwtPrefix + newCompanyToken
        isRefreshCalled = false
        return Promise.resolve(originalRequest)
      } catch (error) {
        isRefreshCalled = false
        return Promise.reject(error)
      }
    }

    return request
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(null, error => {
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500

  if (error.response && error.response.status === 401) {
    // Log out user on 401 Unauthorized response
    localStorage.clear()
    sessionStorage.clear()
    window.location = '/' // redirect to home or login page
    return // stop further execution
  }

  const backendMessage =
    error &&
    error.response &&
    error.response.data &&
    error.response.data.details &&
    error.response.data.details.error

  if (backendMessage) {
    alert(backendMessage)
  } else if (!expectedError) {
    logger.log(error)
    // alert('An Unexpected error Occurred')
  }

  return Promise.reject(error)
})

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch
  // setJwt
}
